export const ROUTE_LICENSE_FRONTIMAGE = 'licenseFrontImage';
export const ROUTE_LICENSE_BACKIMAGE = 'licenseBackImage';
export const ROUTE_LICENSE_SELFIEIMAGE = 'licenseSelfieImage';
export const ROUTE_LICENSE_ALLSET = 'licenseAllset';
export const ROUTE_LICENSE_STATUS = 'licenseStatus';
